module.exports = {
      id: "upload-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-fef6f85605acbf641cce7cd75d6011b0.svg#upload",
      toString: function () {
        return this.url;
      }
    }